exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Grass-module__Grass___2e3ih{display:flex;justify-content:center;align-items:center;height:var(--app-height);width:100vw;background-color:#13aa5f;overflow:hidden}.Grass-module__Grass___2e3ih .Grass-module__top-left___3p9KR{position:fixed;left:-300px;top:30px;z-index:0}.Grass-module__Grass___2e3ih .Grass-module__top-right___1BE9e{position:fixed;right:-140px;top:-40px;z-index:0}.Grass-module__Grass___2e3ih .Grass-module__bottom-right___1i4Va{position:fixed;right:-190px;bottom:-60px;z-index:0}.Grass-module__Grass___2e3ih .Grass-module__bottom-left___1nEyn{position:fixed;left:-10px;bottom:-15px;z-index:0}", ""]);

// exports
exports.locals = {
	"Grass": "Grass-module__Grass___2e3ih",
	"top-left": "Grass-module__top-left___3p9KR",
	"top-right": "Grass-module__top-right___1BE9e",
	"bottom-right": "Grass-module__bottom-right___1i4Va",
	"bottom-left": "Grass-module__bottom-left___1nEyn"
};